import { render } from "./tip_dialog.vue?vue&type=template&id=41272eb3&scoped=true&ts=true"
import script from "./tip_dialog.vue?vue&type=script&lang=ts"
export * from "./tip_dialog.vue?vue&type=script&lang=ts"

import "./tip_dialog.vue?vue&type=style&index=0&id=41272eb3&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41272eb3"]])

export default __exports__